// Time helpers shared by client and server.
// Two formats coexist: employee availability is stored as "7:00AM",
// shifts as "07:00". Everything here accepts either.

function timeToMinutes(time) {
    if (!time) return NaN;
    let str = String(time).trim();

    if (str.includes('AM') || str.includes('PM')) {
        const isPM = str.includes('PM');
        const parts = str.replace('AM', '').replace('PM', '').split(':');
        let hours = parseInt(parts[0], 10);
        const minutes = parseInt(parts[1], 10) || 0;

        if (isPM && hours !== 12) hours += 12;
        if (!isPM && hours === 12) hours = 0;

        return hours * 60 + minutes;
    }

    const [hours, minutes] = str.split(':').map(Number);
    if (isNaN(hours) || isNaN(minutes)) return NaN;
    return hours * 60 + minutes;
}

function minutesToTime(minutes) {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}

// "17:30" or 1050 → "5:30PM"
function toAmPm(time) {
    const total = typeof time === 'number' ? time : timeToMinutes(time);
    if (isNaN(total)) return time;

    const h = Math.floor(total / 60);
    const m = total % 60;
    const suffix = h >= 12 ? 'PM' : 'AM';
    const hour12 = h % 12 === 0 ? 12 : h % 12;

    return `${hour12}:${String(m).padStart(2, '0')}${suffix}`;
}

function calculateShiftHours(shiftTimes) {
    const start = timeToMinutes(shiftTimes.start);
    const end = timeToMinutes(shiftTimes.end);
    return (end - start) / 60;
}

module.exports = { timeToMinutes, minutesToTime, toAmPm, calculateShiftHours };